module.exports = __webpack_public_path__ + "img/circle-half-stroke.859174aa.svg";